import "./privacyPolicy.css";
import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { editIcon } from "../../assets";
import Loader from "../../components/loader/loader";
import PageHeader from "../../components/pageHeader/PageHeader";
import LegalDocModal from "../../components/legalDocModal/LegalDocModal";
import { db } from "../../firebase";
import { collection, getDocs } from "firebase/firestore";
import { RedNotify } from "../../helper/helper";

const documentTypes = {
  PRIVACY_POLICY: {
    id: "0",
    title: "Privacy Policy",
    field: "policy",
    collectionName: "legal_documents",
  },
  TERMS_CONDITIONS: {
    id: "1",
    title: "Terms & Conditions",
    field: "terms",
    collectionName: "legal_documents",
  },
  ABOUT_US: {
    id: "1",
    title: "About Us",
    field: "aboutUs",
    collectionName: "legal_documents",
  },
};

const PrivacyPolicy = ({ documentType = "PRIVACY_POLICY" }) => {
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [document, setDocument] = useState(null);
  const [documents, setDocuments] = useState([]);

  const currentDocConfig = documentTypes[documentType];

  const fetchDocuments = async () => {
    try {
      setLoading(true);
      const querySnapshot = await getDocs(
        collection(db, currentDocConfig.collectionName)
      );

      if (querySnapshot.empty) {
        console.log(`No ${currentDocConfig.title} document found.`);
        RedNotify(`No ${currentDocConfig.title} document found.`);
        return;
      }

      const docs = querySnapshot.docs.map((doc) => ({
        _id: doc.id,
        ...doc.data(),
      }));

      setDocuments(docs);
      setDocument(docs[1]); // Use the first document
      console.log(JSON.stringify(docs));
      console.log(docs[0]);
    } catch (error) {
      console.error(`Error fetching ${currentDocConfig.title}:`, error);
      RedNotify(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDocuments();
  }, [documentType]);

  const handleEditClick = () => {
    setShowModal(true);
  };

  const columns = [
    {
      title: "Description",
      dataIndex: "content",
      align: "center",
      className: "action-column-header",
      render: (text) => (
        <div
          dangerouslySetInnerHTML={{ __html: text }}
          className="legal-document-content"
        />
      ),
    },
    {
      title: "Edit",
      dataIndex: "edit",
      align: "center",
      className: "action-column-header",
      render: () => (
        <div onClick={handleEditClick} className="edit-icon-container">
          <img src={editIcon} alt="Edit" />
        </div>
      ),
    },
  ];

  const data = document
    ? [
        {
          key: document.id,
          content: document[currentDocConfig.field],
        },
      ]
    : [];

  const getRowClassName = () => "legal-document-row";

  return (
    <div className="admin-products-main-container">
      {showModal && (
        <LegalDocModal
          showModal={showModal}
          setShowModal={setShowModal}
          item={document} // Pass the entire document object
          id={"1"}
          // data={documents}
          refreshData={fetchDocuments} // Pass the refresh function
        />
      )}
      <Loader loading={loading} />

      <PageHeader
        eyebrow="Legal"
        title={currentDocConfig.title}
        subtitle="The privacy policy shown to users inside the 2nd Home app. Use the edit action to update its content."
      />

      <div className="server-roles-tb-main-container">
        <Table
          rowClassName={getRowClassName}
          columns={columns}
          dataSource={data}
          pagination={false}
          className="subscriptionapi-table"
        />
      </div>
    </div>
  );
};

export default PrivacyPolicy;
